import React from 'react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="logo-text">Unique</span>
            <span className="logo-accent">Creative</span>
          </div>
          
          <div className="footer-info">
            <p>{companyInfo.fullName} | IČO: {companyInfo.ico}</p>
            <p>{companyInfo.parentCompany}</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>© {currentYear} {companyInfo.fullName}. Všechna práva vyhrazena.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
